import config from "../config";
export default function HelpPage() {
  return (
    <div
      className="flex"
      style={{
        justifyContent: "center",
        marginTop: "70px",
      }}
    >
      <div className="my-2">
        <video width="960" height="540" controls controlsList="nodownload">
          <source src={config.helpGuideUrl} type="video/mp4" />
        </video>
      </div>
    </div>
  );
}
